import { ApplicationConfig ,importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';

import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalService, ProtectedResourceScopes } from '@azure/msal-angular';
import { loginRequest, msalConfig} from './auth.config';
import { genericErrorHandlerInterceptor } from './shared/interceptors/generic-error-handler.interceptor';
import { ApiKeyInterceptor } from './shared/interceptors/api-key-interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { EnvironmentConfigService } from './shared/services/environment-config.service';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest
  };
}

/**
 * MSAL Angular will automatically retrieve tokens for resources
 * added to protectedResourceMap. For more info, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/initialization.md#get-tokens-for-web-api-calls
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const openIdConfigConfig = EnvironmentConfigService.getOpenIdConfig();

    const protectedResourceMap = new Map<string, Array<string | ProtectedResourceScopes>>();

    // Define your list of endpoints and HTTP methods
    const protectedPaths = [
        { method: 'GET', path: `/user/users/me` },
        { method: 'PUT', path: `/user/users` },
        { method: 'POST', path: `/user/users` }, 
        { method: 'PUT', path: `/user` },
        { method: 'GET', path: `/search` },
        { method: 'POST', path: `/search/coilsheets` },
        { method: 'POST', path: `/search/orders` },
        { method: 'POST', path: `/search/odin` },
        { method: 'POST', path: `/report` },
        { method: 'GET', path: `/demos/validate`},
        { method: 'GET', path: `/users/secondaryCompanyList`}
        // Add more entries as needed for other endpoints and methods
    ];

    // Generate resource configurations for each endpoint and method combination and add to protectedResourceMap
    protectedPaths.forEach(entry => {
        protectedResourceMap.set(entry.path, [
            {
                httpMethod: entry.method,
                scopes: [`${openIdConfigConfig.clientId}/.default`] // Adjust scopes as needed
            }
        ]);
    });

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideNoopAnimations(),
    provideToastr(),
    provideHttpClient(withInterceptors([genericErrorHandlerInterceptor])),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(HttpClientModule),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory
    },
    {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory
    },
    {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiKeyInterceptor,
      multi: true
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService, provideAnimationsAsync()
  ]
};
